import axios from 'axios';
import authHeader from '../services/auth.header';

const API_URL = `${process.env.REACT_APP_API_HOST}/v1`;
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getPath = (url) => `${API_URL}/${url}`;

export const axiosGetPublic = (url, extraConfigs = {}) => {	
	const config = {
		headers: {
			type: 'application/json',
			timezone
		},
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.get(getPath(url), config);
};

export const axiosPostPublic = (url, data, extraConfigs = {}) => {
	const config = {
		headers: {
			type: 'application/json',
			timezone
		},
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.post(getPath(url), data, config);
};

export const axiosPutPublic = (url, data, extraConfigs = {}) => {
	const config = {
		headers: {
			type: 'application/json',
			timezone
		},
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.put(getPath(url), data, config);
};

export const axiosGet = (url, params={}, extraConfigs = {}) => {
	const auth = authHeader()
	const config = {
		headers: {
			type: 'application/json',
			timezone,
			...auth
		},
		params,
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.get(getPath(url), config);
};

export const axiosPost = (url, data, params={}, extraConfigs = {}) => {
	const auth = authHeader()
	const config = {
		headers: {
			type: 'application/json',
			timezone,
			...auth
		},
		params,
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.post(getPath(url), data, config);
};

export const axiosPatch = (url, data, params={}, extraConfigs = {}) => {
	const auth = authHeader()
	const config = {
		headers: {
			type: 'application/json',
			timezone,
			...auth
		},
		params,
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.patch(getPath(url), data, config);
};

export const axiosPut = (url, data, params={}, extraConfigs = {}) => {
	const auth = authHeader()
	const config = {
		headers: {
			type: 'application/json',
			timezone,
			...auth
		},
		params,
		timeout: 300000, // 5 min timeout
		...extraConfigs,
	};
	return axios.put(getPath(url), data, config);
};

export const axiosDelete = (url,data,extraConfigs = {}) => {
	const auth = authHeader()
	const config = {
		headers: {
			type: 'application/json',
			timezone,
			...auth
		},
		timeout: 300000, // 5 min timeout
		...extraConfigs,
		data,
	};

	return axios.delete(getPath(url), config);
};



export const handleOnError = (error) => {
	return new Promise((resolve, reject) =>{
		if(error.response && error.response.data && error.response.data.message){
			resolve({ 'warning' : error.response.data.message});
		}
		resolve({'error' : "Somthing went wrong. Try again"});
	});
};
